import styled from '@emotion/styled/macro';
import { Handle } from '@xyflow/react';
import { colors, views } from '../../../../common/styles/theme.styles';

export const NodeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 20px 8px 12px;
  background: #FFFFFF;
  border: 1px solid ${colors.gray2};
  border-radius: 12px;
  min-width: 160px;
  max-width: 220px;
  position: relative;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
  outline: none;
  
  &:hover {
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.24), 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-color: ${colors.darkGray1};
    background: #FFFFFF;
  }
  
  ${({ isSelected }) => isSelected && `
    border: 1px solid ${colors.gray2};
    background: #FFFFFF;
    outline: none !important;
    box-shadow: none !important;
  `}
  
  ${views.mobile} {
    padding: 8px 20px 10px 16px;
    height: 56px;
    box-sizing: border-box;
  }
`;

// Entity icon with exact Figma styling
export const EntityIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${props => props.color || '#DACEE0'};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  font-family: Circular;
  font-weight: 500;
  font-size: 12px;
  color: ${colors.darkGray1};
  
  svg {
    width: 18px;
    height: 18px;
  }
`;

// Content area for entity info
export const EntityContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1;
  gap: 2px;
`;

// Entity name with exact Figma typography
export const EntityName = styled.div`
  font-family: Circular;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.265;
  color: ${colors.darkGray1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
`;

// Meta info (item count) matching Figma
export const EntityMeta = styled.div`
  font-family: Circular;
  font-weight: 450;
  font-size: 12px;
  line-height: 1.265;
  color: ${colors.darkGray3};
  white-space: nowrap;
`;

// Visible handles for ReactFlow connections matching Figma design
export const StyledHandle = styled(Handle)`
  width: 8px;
  height: 8px;
  background: transparent;
  border: 1px solid ${colors.darkGray3};
  border-radius: 50%;
  opacity: 1;
  position: absolute;
  z-index: 10;

  &:hover {
    border: 1px solid ${colors.darkGray1};
  }
  
  &.react-flow__handle-top {
    top: -4px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
  }
  
  &.react-flow__handle-bottom {
    bottom: -4px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
  }
  
  .mobile & {
    width: 16px;
    height: 16px;
  }
  
  .mobile &.react-flow__handle-top {
    top: -8px;
  }
  
  .mobile &.react-flow__handle-bottom {
    bottom: -8px;
  }
`;

export const OuterSelectionBorder = styled.div`
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border: 2px solid rgba(189, 203, 222, 0.5);
  border-radius: 15px;
  pointer-events: none;
  box-sizing: border-box;
`;

export const InnerSelectionBorder = styled.div`
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid #1A1B1D;
  border-radius: 13px;
  pointer-events: none;
  box-sizing: border-box;
`; 